export const parseDate = (dateString: string | null | undefined): Date | null => {
  if (!dateString) return null;

  const cleaned = dateString.trim();

  // Handle DD/MM/YYYY or DD-MM-YYYY format (prioritize this over ISO if separators are found)
  const match = cleaned.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
  if (match) {
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1; // months are 0-indexed
    const year = parseInt(match[3], 10);

    const parsedDate = new Date(year, month, day);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate;
    }
  }

  // Handle YYYY-MM-DD (ISO format)
  const isoMatch = cleaned.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const year = parseInt(isoMatch[1], 10);
    const month = parseInt(isoMatch[2], 10) - 1;
    const day = parseInt(isoMatch[3], 10);
    
    const parsedDate = new Date(year, month, day);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate;
    }
  }

  // Fallback to standard parsing for other formats
  const date = new Date(cleaned);
  if (!isNaN(date.getTime())) {
    return date;
  }

  return null;
};
